import moment from 'moment';

import { isIsoString } from './isISOString';

/**
 * Check object's fields on ISO date format and transform it to the moment() instance.
 *
 * @param {object} obj Input object.
 */
export function momentizeObjectValues(object) {
  Object.keys(object).forEach(key => {
    if (isIsoString(object[key])) {
      // eslint-disable-next-line no-param-reassign
      object[key] = moment(object[key]);
    }
  });
}
